import blockDrop from '../../components/other/NBlockDropdown/blockDropdown';
import blockTabs from '../../components/other/NTabsInBlockDown/blockTabs';
import Dropdown from '../../components/other/NDropdown/Dropdown';
import Tabs from '../../components/other/NTabs/Tabs';
import LineTabs from '../../components/other/NLineTabs/LineTabs';
import Swiper, { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import './bilet.scss';

(function () {
	const childBtn = document.querySelectorAll('.child-document-show');
	const oldBtn = document.querySelectorAll('.old-document-show');
	const oldBtnscnd = document.querySelectorAll('.old-document-show-second');
	const childDoc = document.getElementById('child-document');
	const oldDoc = document.getElementById('old-document');
	const oldDocScnd = document.getElementById('old-document-second');
	const $blockDrop = document.querySelectorAll('.js-blockDrop');
	const $blockTabs = document.querySelectorAll('.js-blockTabs');
	const $lineTabs = document.querySelectorAll('.js-line-tabs');
	const $dropdownList = document.querySelectorAll('.js-dropdown');
	const $tabs = document.querySelectorAll('.js-tabs');
	const $menuButton = document.querySelector('.js-menu-button');
	const $menuContent = document.querySelector('.menu__content');
	const $body = document.querySelector('.body');
	const $sliderBilet = document.querySelector('.swiper-bilet');
	const $sliderProgram = document.querySelector('.swiper-container-two');
	const $sliderProgramTwo = document.querySelector('.swiper-container');
	const $sliderAnalizesAdult = document.querySelector('.swiper-analizes-adult');
	const $sliderAnalizesKids = document.querySelector('.swiper-analizes-kids');
	const blockOne = document.querySelectorAll('.js-blockDrop-name-one');
	const blockTwo = document.querySelectorAll('.js-blockDrop-name-two');
	const downOne = document.getElementById('category-1');
	const downTwo = document.getElementById('category-2');
	const downthree = document.getElementById('to-block');
	const blockHow = document.getElementById('block-how');
	const buttonElOne = document.getElementById('next');
	const buttonElTwo = document.getElementById('prev');
	const secondButtonElOne = document.getElementById('nextTwo');
	const secondButtonElTwo = document.getElementById('prevTwo');
	const biletPromoButton = document.querySelector('.biletPromo-banner1__link');
	const buttonsCardsAnalyzes = document.querySelectorAll('.js-button-analyzes');
	const AnalizesLists = document.querySelectorAll('.biletPromo__analyzes-card-analyzes');
	let content = document.querySelector('.biletPromo__dropdown-content');



	childBtn.forEach(function (button) {
		button.addEventListener('click', function () {
			childDoc.style.display = 'flex';
			oldDoc.style.display = 'none';
			oldDocScnd.style.display = 'none';
		});
	});

	oldBtn.forEach(function (button) {
		button.addEventListener('click', function () {
			childDoc.style.display = 'none';
			oldDocScnd.style.display = 'none';
			oldDoc.style.display = 'flex';
		});
	});

	oldBtnscnd.forEach(function (button) {
		button.addEventListener('click', function () {
			childDoc.style.display = 'none';
			oldDoc.style.display = 'none';
			oldDocScnd.style.display = 'flex';
		});
	});

	document.addEventListener('DOMContentLoaded', function () {
		var swiperProgram = new Swiper($sliderProgram, {
			slidesPerView: 1,
			spaceBetween: 30,
			breakpoints: {
				550: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		});
		secondButtonElOne.addEventListener('click', () => {
			swiperProgram.slideNext();
		});
		secondButtonElTwo.addEventListener('click', () => {
			swiperProgram.slidePrev();
		});

		var swiperProgramTwo = new Swiper($sliderProgramTwo, {
			slidesPerView: 1,
			spaceBetween: 30,
			breakpoints: {
				550: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		});
		buttonElOne.addEventListener('click', () => {
			swiperProgramTwo.slideNext();
		});
		buttonElTwo.addEventListener('click', () => {
			swiperProgramTwo.slidePrev();
		});
	});

	downthree.addEventListener('click', function () {
		blockHow.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
	});

	blockOne.forEach(function (button) {
		button.addEventListener('click', function () {
			if (!button.classList.contains('active')) {
				downOne.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
			}
		});
	});
	blockTwo.forEach(function (button) {
		button.addEventListener('click', function () {
			if (!button.classList.contains('active')) {
				downTwo.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
			}
		});
	});

	var swiperInstance = new Swiper($sliderBilet, {
		modules: [Pagination, Autoplay],
		speed: 1000,
		loop: true,
		breakpoints: {
			350: {
				slidesPerView: 1.04,
			},
			380: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
		},
		autoplay: {
			delay: 4000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			renderBullet: function (index, className) {
				return (
					'<span class="' +
					className +
					'">' +
					'<svg class="fp-arc-loader" width="16" height="16" viewBox="0 0 16 16">' +
					'<circle class="path" cx="8" cy="8" r="5.5" fill="none" transform="rotate(-90 8 8)" stroke="#26C93C"' +
					'stroke-opacity="1" stroke-width="1.5px"></circle>' +
					'<circle class="inner-circle" cx="8" cy="8" r="3" fill="none" stroke="#26C93C" stroke-opacity="1" stroke-width="1px"></circle>' +
					'</svg></span>'
				);
			},
		},
		on: {
            slideChange: function () {
                updateAltAttributesBilet();
            },
            transitionEnd: function () {
                updateAltAttributesBilet();
            }
        },
	});

	function updateAltAttributesBilet() {
        const slides = $sliderBilet.querySelectorAll('.swiper-bilet img');
        slides.forEach((img, index) => {
            img.setAttribute('alt', `Билет в будущее фото №${index + 5}`);
        });
    };

	function simulateClick() {
		swiperInstance.slideNext();
	}

	// Установите интервал для имитации кликов
	setInterval(simulateClick, 4001);

	// Добаввление свойство блокировки прокрутки body при активном меню
	// $menuButton.addEventListener('click', toggleMenu);
	//

	$blockDrop.forEach((tab) => {
		new blockDrop(tab);
	});

	$blockTabs.forEach((tab) => {
		new blockTabs(tab);
	});

	$lineTabs.forEach((lineTab) => {
		new LineTabs(lineTab);
	});

	$tabs.forEach((tab) => {
		new Tabs(tab);
	});
	$dropdownList.forEach((dropdown) => {
		new Dropdown(dropdown);
	});
	console.log(156, 'bilet');
	const button = document.querySelector('.b-footer__agreement_link2');
	button.addEventListener('click', function () {
		button.classList.toggle('active');
	});

	if(biletPromoButton) {
		biletPromoButton.addEventListener('click', function () {
			let content = document.querySelector('.biletPromo__dropdown-content');
			content.classList.toggle('active');
			if (content.style.maxHeight) {
				content.style.maxHeight = null;
			} else {
				// content.style.maxHeight = 100 + '%';
				content.style.maxHeight = content.scrollHeight + 'px';
			}
		});
	}

	window.addEventListener('resize', () => {
		content.style.maxHeight = content.scrollHeight + 'px';
	});
})();
